import React from 'react';
import moment from 'moment';

import LabelSection from 'components/sections/LabelSection';

import {
  NAMESPACE_ITEMS,
  NAMESPACE_INGREDIENTS,
} from 'actions/inventory/constants';
import styles from './TransferDetail.css';

export default class ItemDetails extends React.Component {
  render() {
    const { transferDetail, searchForm } = this.props;

    return (
      transferDetail && (
        <div>
          {searchForm && searchForm.namespace === NAMESPACE_ITEMS && (
            <LabelSection title="item details" />
          )}
          {searchForm && searchForm.namespace === NAMESPACE_INGREDIENTS && (
            <LabelSection title="ingredient details" />
          )}
          <div className="row mb-5px">
            <div className="col-sm-2">
              <span>Date</span>
            </div>
            <div className="col-sm-10">
              <div className="text-right">
                <span>
                  {moment(transferDetail.created_at).format(
                    'DD MMMM YYYY HH:mm'
                  )}
                </span>
              </div>
            </div>
            <div className="col-sm-12">
              <div className={styles['separator-row']} />
            </div>
          </div>
          {searchForm && searchForm.outletIds.length > 1 && (
            <div className="row mb-5px">
              <div className="col-sm-3">
                <span>From Outlet</span>
              </div>
              <div className="col-sm-9">
                <div className="text-right">
                  {searchForm && searchForm.namespace === NAMESPACE_INGREDIENTS
                    ? transferDetail.outlet_sender_name
                    : transferDetail.from_outlet_name}
                </div>
              </div>
              <div className="col-sm-12">
                <div className={styles['separator-row']} />
              </div>
            </div>
          )}
          <div className="row mb-5px">
            <div className="col-sm-3">
              <span>To Outlet</span>
            </div>
            <div className="col-sm-9">
              <div className="text-right">
                {searchForm && searchForm.namespace === NAMESPACE_INGREDIENTS
                  ? transferDetail.outlet_receiver_name
                  : transferDetail.to_outlet_name}
              </div>
            </div>
            <div className="col-sm-12">
              <div className={styles['separator-row']} />
            </div>
          </div>
          <div className="row mb-5px">
            <div className="col-sm-2">
              <span>Note</span>
            </div>
            <div className="col-sm-10">
              <div className="text-right">{transferDetail.note}</div>
            </div>
            <div className="col-sm-12">
              <div className={styles['separator-row']} />
            </div>
          </div>
        </div>
      )
    );
  }
}
